// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setCaregiverProfile,
  resetCaregiverProfile
} from 'src/store/modules/caregiver/profile'

const initialState = {}

export default handleActions(
  {
    [setCaregiverProfile](__, { payload: caregiverProfile }) {
      return caregiverProfile
    },

    [resetCaregiverProfile]() {
      return initialState
    }
  },
  initialState
)
